import axios from 'axios';

const envBaseUrl = process.env.REACT_APP_PRESSHUNT_AUTH_SERVICES_BASE_DOMAIN;
const isLocal =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');
const BASE_URL = isLocal ? '' : envBaseUrl;

export const postIdTokenToSessionLogin = (idToken, csrfToken) => {
  // In local dev, the auth services endpoint may not be reachable. Skip session cookies.
  if (isLocal) {
    return Promise.resolve({ data: {} });
  }

  return axios.post(`${BASE_URL}/api/sessionLogin`, {
  idToken,
  csrfToken,
});
};
